import { Col, Row } from 'antd/lib/grid';
import Text from 'antd/lib/typography/Text';
import Checkbox from 'antd/lib/checkbox';
import React from 'react';
import { MagnetModeType } from '../../../../reducers';

interface Props {
    defaultMagnetConfig?: MagnetModeType[];
    onChangeMagnetConfig(checkedValues: MagnetModeType[]): void;
}

function MagnetConfigPopoverComponent(props: Props): JSX.Element {
    const {
        onChangeMagnetConfig,
        defaultMagnetConfig = [], // Значение по умолчанию, если проп не передан
    } = props;

    const [selectedModes, setSelectedModes] = React.useState<MagnetModeType[]>(defaultMagnetConfig);
    const handleModeChange = (checkedValues: MagnetModeType[]) => {
        setSelectedModes(checkedValues);
        onChangeMagnetConfig(checkedValues);
    };

    return (
        <div className='cvat-draw-shape-popover-content'>
            <Row justify='start'>
                <Col>
                    <Text className='cvat-text-color' strong>Режимы привязки</Text>
                </Col>
            </Row>

            <Row justify='space-around'>
                <Col>
                    <Checkbox.Group
                        style={{ display: 'flex' }}
                        value={selectedModes}
                        onChange={handleModeChange}
                    >
                        <Checkbox value={MagnetModeType.POINT} style={{ width: 'auto' }}>
                            Привязка к вершинам
                        </Checkbox>
                        <Checkbox value={MagnetModeType.LINE} style={{ width: 'auto' }}>
                            Линии привязки (ctrl)
                        </Checkbox>
                        <Checkbox value={MagnetModeType.EDGE} style={{ width: 'auto' }}>
                            Скольжение по граням (ctrl+shift)
                        </Checkbox>
                    </Checkbox.Group>
                </Col>
            </Row>
        </div>
    );
}

export default React.memo(MagnetConfigPopoverComponent);
